import { render, staticRenderFns } from "./ToysIndex.vue?vue&type=template&id=6910e87c"
import script from "./ToysIndex.vue?vue&type=script&lang=js"
export * from "./ToysIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports